export const urlShortenerServer = {
    baseURL: "https://urlshortener-api.steady.darvis.dev",
    tikTokURL: "dailyvanity.sg/tiktok/"
  }
  

